(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86970],{

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-d08cd954-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 86970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mulai_investasi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 50px);\n  margin: auto;\n  @media ",
        " {\n    max-width: 1300px;\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 100px;\n  font-size: 44px;\n\n  .header-title {\n    font-size: 48px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  @media ",
        " {\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n    margin: 20px auto;\n\n    @media ",
        " {\n      margin: 20px 0;\n    }\n  }\n\n  h2 {\n    margin-bottom: 10px;\n    text-align: center;\n\n    @media ",
        " {\n      margin: 20px 0;\n      text-align: left;\n    }\n  }\n\n  @media ",
        " {\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9b7d980-0"
})(_templateObject(), device/* default.tablet */.Z.tablet);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h2",
    family: "bold",
    align: "center"
}).withConfig({
    componentId: "sc-9b7d980-1"
})(_templateObject1());
var Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "p",
    color: color/* default.dimgray */.Z.dimgray
}).withConfig({
    componentId: "sc-9b7d980-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);
var Item = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9b7d980-3"
})(_templateObject3(), device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 75px 0;\n\n  img {\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n  }\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n\n    .benefit__sized {\n      width: 25%;\n      margin-right: 75px;\n    }\n\n    .benefit__sized:last-child {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// eslint-disable-next-line import/prefer-default-export
var BenefitsContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-41f3a25f-0"
})(styled_templateObject(), device/* default.laptop */.Z.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/constants.ts
var benefits = [
    {
        image: "/images/mulai-investasi/benefit1.png",
        title: "Mudah Digunakan",
        desc: "Di design oleh investor khusus untuk investor. Mulai berinvestasi tanpa manual. <br /> Swipe. Order. Done."
    },
    {
        image: "/images/mulai-investasi/benefit2.png",
        title: "Keamanan Generasi Terbaru",
        desc: "Dilengkapi dengan teknologi keamanan yang canggih menggunakan Fingerprint dan Face ID untuk kemudahan dan keamanan Anda."
    },
    {
        image: "/images/mulai-investasi/benefit3.png",
        title: "Dana Anda Aman",
        desc: "Semua dana Anda akan disimpan di rekening terpisah di Rekening Dana Nasabah (RDN) atas nama Anda sendiri sehingga tidak dapat disalahgunakan oleh pihak lain."
    },
    {
        image: "/images/mulai-investasi/benefit4.png",
        title: "Personal Customer Support",
        desc: "Tim support kami selalu siap untuk membantu masalah Anda lewat live chat support kami."
    }, 
];
/* harmony default export */ var constants = (benefits);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/index.tsx






var MulaiInvestasiBenefits = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsContainer, {
        children: constants.map(function(b) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                className: "benefit__sized",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: b.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "30px",
                        family: "bold",
                        as: "h2",
                        children: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        size: "17px",
                        dangerouslySetInnerHTML: {
                            __html: b.desc
                        }
                    })
                ]
            }, b.title);
        })
    });
};
/* harmony default export */ var Benefits = (MulaiInvestasiBenefits);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/ComparisonGraph/styled.ts

function ComparisonGraph_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 100px 0;\n\n  h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    @media ",
        " {\n      text-align: left;\n    }\n  }\n\n  &>.note {\n    margin-top: 20px;\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  .note {\n    p {\n      display: block;\n      padding-left: 15px;\n      position: relative;\n\n      &:before {\n        content: '*)';\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n  }\n"
    ]);
    ComparisonGraph_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: 0.6fr 1.4fr;\n    grid-template-rows: 1fr;\n    grid-column-gap: 50px;\n    grid-row-gap: 0px; \n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  .note {\n    display: none;\n    @media ",
        " {\n      display: block;\n    }\n  }\n\n  @media ",
        " {\n    justify-content: space-between;\n    padding: 58px 0;\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n\n  > div {\n    width: 100%;\n    margin-bottom: 20px;\n    div {\n      text-align: center;\n      align-items: center;\n      justify-content: center;\n\n      @media ",
        " {\n        justify-content: flex-start;\n        text-align: left;\n      }\n    }\n\n\n    @media ",
        " {\n      width: 50%;\n      margin: 10px 10px 50px 10px;\n    }\n\n    @media ",
        " {\n      width: 100%;\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  flex-direction: column-reverse;\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0;\n  border-bottom: solid 1px ",
        ";\n  font-family: inherit;\n  font-weight: bold;\n  font-size: 30px;\n  color: ",
        ";\n  width: auto;\n  max-width: 90%;\n\n  &:focus {outline: none; border-bottom: solid 1px ",
        "}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  margin: 25px 0;\n  width: 384px;\n\n  > div {\n    width: 50%;\n    margin-right: 25px;\n  }\n  .sfaqchart-l {\n    width: 15px;\n    height: 10px;\n    margin-top: 4px;\n    margin-right: 10px;\n\n    &.l-deposito {\n      background-color: #0099e5;\n    }\n\n    &.l-saham {\n      background-color: #34bf49;\n    }\n  }\n  @media ",
        " {\n    margin: 0 0 25px 105px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var ComparisonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-cf5714e3-0"
})(ComparisonGraph_styled_templateObject(), device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop);
var GraphContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-cf5714e3-1"
})(styled_templateObject1(), device/* default.laptop */.Z.laptop);
var GraphSidebar = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-cf5714e3-2"
})(styled_templateObject2(), device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop);
var GraphInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "space-between",
    align: "flex-start"
}).withConfig({
    componentId: "sc-cf5714e3-3"
})(styled_templateObject3(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var GraphContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cf5714e3-4"
})(_templateObject4(), device/* default.laptop */.Z.laptop);
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-cf5714e3-5"
})(_templateObject5(), color/* default.gainsboro */.Z.gainsboro, color/* default.nightRider */.Z.nightRider, color/* default.primary */.Z.primary);
var GraphContentInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "row",
    justify: "space-between",
    align: "flex-start"
}).withConfig({
    componentId: "sc-cf5714e3-6"
})(_templateObject6(), device/* default.laptop */.Z.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/ComparisonGraph/index.tsx








var options = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        }
    },
    scales: {
        y: {
            ticks: {
                font: {
                    family: "ProximaNovaRg",
                    size: 15
                },
                callback: function callback(value) {
                    return numeral_default()(value).format("0.0 a").toUpperCase();
                }
            }
        },
        x: {
            ticks: {
                font: {
                    family: "ProximaNovaRg",
                    size: 15
                }
            }
        }
    }
};
var Note = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "note",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            color: color/* default.dimgray */.Z.dimgray,
            size: "14px",
            children: [
                "Asumsi konservatif berdasarkan pertumbuhan IHSG sebesar 19.7% per tahun selama 15 tahun terakhir.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " Simulasi ini berdasarkan kinerja masa lalu dan tidak menjanjikan kinerja masa depan."
            ]
        })
    });
};
var ComparisonGraph = function() {
    var depositYearlyInterest = 0.00417;
    var stockYearlyInterest = 0.011715;
    var initialMonthlyDeposit = 1000000;
    var ref = (0,react.useState)(initialMonthlyDeposit), monthlyDeposit = ref[0], setMonthlyDeposit = ref[1];
    var ref1 = (0,react.useState)(numeral_default()(initialMonthlyDeposit).format("0,0")), monthlyDepositValue = ref1[0], setMonthlyDepositValue = ref1[1];
    var ref2 = (0,react.useState)(21), savingPeriod = ref2[0], setSavingPeriod = ref2[1];
    var ref3 = (0,react.useState)([]), depositValueOverTime = ref3[0], setDepositValueOverTime = ref3[1];
    var ref4 = (0,react.useState)([]), chartPeriods = ref4[0], setChartPeriods = ref4[1];
    var ref5 = (0,react.useState)([]), stocksValueOverTime = ref5[0], setStocksValueOverTime = ref5[1];
    var ref6 = (0,react.useState)({
        labels: chartPeriods,
        datasets: [
            {
                pointRadius: 0,
                borderColor: "#0099e5",
                backgroundColor: "rgba(255,255,255,0)",
                label: "deposito, kenaikan 5% p.a",
                data: depositValueOverTime
            },
            {
                pointRadius: 0,
                borderColor: "#34bf49",
                backgroundColor: "rgba(255,255,255,0)",
                label: "investasi saham, kenaikan 15% p.a",
                data: stocksValueOverTime
            }, 
        ]
    }), data = ref6[0], setData = ref6[1];
    var generateSchemePeriod = function() {
        var newChartPeriods = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            newChartPeriods.push(year);
        }
        setChartPeriods(newChartPeriods);
    };
    var generateBankDepositScheme = function() {
        var newDepositValueOverTime = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            var depositValueYearly = (monthlyDeposit + monthlyDeposit / depositYearlyInterest) * Math.pow(1 + depositYearlyInterest, year * 12) - monthlyDeposit / depositYearlyInterest;
            newDepositValueOverTime.push(Math.round(depositValueYearly));
        }
        setDepositValueOverTime(newDepositValueOverTime);
    };
    var generateStockScheme = function() {
        var newStocksValueOverTime = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            var stockValueYearly = (monthlyDeposit + monthlyDeposit / stockYearlyInterest) * Math.pow(1 + stockYearlyInterest, year * 12) - monthlyDeposit / stockYearlyInterest;
            newStocksValueOverTime.push(Math.round(stockValueYearly));
        }
        setStocksValueOverTime(newStocksValueOverTime);
    };
    (0,react.useEffect)(generateSchemePeriod, [
        savingPeriod
    ]);
    (0,react.useEffect)(generateStockScheme, [
        savingPeriod,
        monthlyDeposit,
        stockYearlyInterest, 
    ]);
    (0,react.useEffect)(generateBankDepositScheme, [
        savingPeriod,
        monthlyDeposit,
        depositYearlyInterest, 
    ]);
    (0,react.useEffect)(function() {
        var newData = {
            labels: chartPeriods,
            datasets: [
                {
                    radius: 0,
                    borderColor: "#0099e5",
                    backgroundColor: "rgba(255,255,255,0)",
                    label: "deposito, kenaikan 5% p.a",
                    data: depositValueOverTime
                },
                {
                    radius: 0,
                    borderColor: "#34bf49",
                    backgroundColor: "rgba(255,255,255,0)",
                    label: "investasi saham, kenaikan 15% p.a",
                    data: stocksValueOverTime
                }, 
            ]
        };
        setData(newData);
    }, [
        depositValueOverTime,
        chartPeriods,
        stocksValueOverTime
    ]);
    var calculateWidth = function(value) {
        return "".concat(String(value || 2).length * 23, "px");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "40px",
                family: "bold",
                as: "h2",
                children: "Grafik Perbandingan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphSidebar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphInputContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "19px",
                                                as: "div",
                                                children: "Investasi per Bulan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        size: "19px",
                                                        as: "div",
                                                        padding: "0 10px 0 0",
                                                        children: "Rp"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        family: "bold",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                            value: monthlyDepositValue,
                                                            onChange: function(e) {
                                                                e.preventDefault();
                                                                var value = numeral_default()(e.target.value).value();
                                                                setMonthlyDeposit(value);
                                                                setMonthlyDepositValue(numeral_default()(value).format("0,0"));
                                                            },
                                                            style: {
                                                                width: calculateWidth(monthlyDepositValue)
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "19px",
                                                as: "div",
                                                children: "Jangka Waktu Investasi"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        family: "bold",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                            value: savingPeriod,
                                                            onChange: function(e) {
                                                                e.preventDefault();
                                                                var value = numeral_default()(e.target.value).value();
                                                                setSavingPeriod(value);
                                                            },
                                                            style: {
                                                                width: calculateWidth(savingPeriod)
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        size: "19px",
                                                        as: "div",
                                                        padding: "0 0 0 10px",
                                                        children: "Tahun"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Note, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContentInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sfaqchart-l l-deposito"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                size: "15px",
                                                as: "div",
                                                children: [
                                                    "Kenaikan Deposito ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "5% per tahun"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sfaqchart-l l-saham"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                size: "15px",
                                                as: "div",
                                                children: [
                                                    "Kenaikan IHSG",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " 15% per tahun *)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
                                options: options,
                                data: data
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Note, {})
        ]
    });
};
/* harmony default export */ var mulai_investasi_ComparisonGraph = (ComparisonGraph);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/constants.ts
var features = [
    {
        image: "/images/mulai-investasi/feature1.png",
        title: "Platform Charting Modern",
        desc: "Tingkatkan analisis teknikal Anda dengan fitur charting canggih. Dilengkapi live price data dan ratusan indikator yang siap dipakai untuk membantu Anda mengambil keputusan trading."
    },
    {
        image: "/images/mulai-investasi/feature2.png",
        title: "Screener Terbaik",
        desc: "Cari dan pilih saham sesuai dengan kriteria yang Anda inginkan. Buat sendiri aturan screening dengan ratusan kriteria yang tersedia atau gunakan langsung preset screener dengan kriteria para <i>guru</i> saham terkenal."
    },
    {
        image: "/images/mulai-investasi/feature3.png",
        title: "Data Finansial yang Lengkap",
        desc: "Disajikan dalam berbagai jenis periode dengan data historikal hingga lebih dari 10 tahun. Dilengkapi dengan rasio-rasio keuangan dan data yang akurat dan terpercaya langsung dari sumber resmi."
    },
    {
        image: "/images/mulai-investasi/feature4.png",
        title: "PE Standard Deviation Band",
        desc: "Tools canggih yang sering digunakan oleh institusi dan pemain besar untuk mengetahui apakah suatu saham masih murah atau sudah mahal secara cepat dan mudah."
    }, 
];
/* harmony default export */ var Features_constants = (features);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/styled.ts

function Features_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background: no-repeat center right / 16px auto;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG2SURBVGhD7Zi/LwRREMcHodAo0BGNQohEoqBQEYma+AMUNm7eXaGQiMKV/AEKEqUf2XmH5HqNSqGi1BCdSkIkkuPM25uTW3ul4ibmk0wut+9bzCf73tt9C4ZhGIZhGMY/4jjqg2KxXf4ppApt4J3nqoLHRyCckBFlEM7UJOqFzxDjsIwqIi6MArmvlAy5BzgrDEhCEbHbTokkhbcs2S8JRRDuZWTIXUM56paEEmqL/igj4/ESqNglKSWEhsmVszK8q9Fyh6SUEKYS4VUTmf3krqmCop5ksWdldiTRhHPXC5SbbLmKcYEbf/klUuXrG9J5Ax7XuT4z4Vau8MwhtyIGTG2XyBrrqAo/e+bFhCF31ySkoe7TD8tSfoRlYh64adF65UpLED7BaW5QDBRQckvceCUtwi+UHsckoYA4P8sNf6Qlwt3BKUkoIDTr8S0twVJBTg2xG+emefo0SoTplVuUhAJKOJQs5EaJ5JyCq5JQQNhKw5baKJGI4KYkFBA+OIRzR1ZiVxJKOFubzkh4PNT3phvO5h7ffyQIL/SdPep4nOPpdcK/W3AQdcpVwzAMwzAMw/gLAL4BSNemrTyIDIIAAAAASUVORK5CYII=');\n  color: ",
        ";\n  font-size: 14px;\n  margin: auto;\n  padding-right: 30px;\n  @media ",
        " {\n    margin: 0;\n  }\n\n  b {\n    font-family: var(--bold-font);\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    Features_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Features_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 50px auto;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: 0.6fr 1.4fr;\n    grid-template-rows: 1fr;\n    grid-column-gap: 100px;\n    grid-row-gap: 100px;\n  }\n"
    ]);
    Features_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Features_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n\n  p {\n    margin: 10px 0;\n  }\n\n  h2 {\n    margin-top: 0;\n    font-size: 40px;\n    text-align: center;\n    display: block;\n    width: 100%;\n\n    @media ",
        " {\n      text-align: left;\n    }\n  }\n"
    ]);
    Features_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Features_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(4, 1fr);\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    grid-column-gap: 80px;\n    grid-row-gap: 0px;\n\n    img {\n      margin: 25px 0;\n    }\n  }\n"
    ]);
    Features_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ProceedLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-39abb78-0"
})(Features_styled_templateObject(), color/* default.primary */.Z.primary, device/* default.laptop */.Z.laptop, color/* default.primary */.Z.primary);
var FeatureContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-39abb78-1"
})(Features_styled_templateObject1(), device/* default.laptop */.Z.laptop);
var FeatureSidebar = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-39abb78-2"
})(Features_styled_templateObject2(), device/* default.laptop */.Z.laptop);
var FeatureList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-39abb78-3"
})(Features_styled_templateObject3(), device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/index.tsx







var MulaiInvestasiFeatures = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureSidebar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "Fitur Investasi Terlengkap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        size: "16px",
                        children: "Pertajam analisis Anda dalam berinvestasi dengan fitur-fitur professional. Tingkatkan potensi untuk mendapatkan keuntungan yang maksimal."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/info/pro-tools",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProceedLink, {
                            children: "Pelajari Lebih Lanjut"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                children: Features_constants.map(function(b) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: b.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "19px",
                                family: "bold",
                                as: "h2",
                                children: b.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                size: "16px",
                                dangerouslySetInnerHTML: {
                                    __html: b.desc
                                }
                            })
                        ]
                    }, b.title);
                })
            })
        ]
    });
};
/* harmony default export */ var Features = (MulaiInvestasiFeatures);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Header/styled.ts

function Header_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: flex-end;\n  min-height: 100vh;\n\n  @media ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    Header_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 120px;\n  font-size: 48px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 60px;\n    text-align: left;\n  }\n"
    ]);
    Header_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: 60%;\n    padding-right: 50px;\n  }\n"
    ]);
    Header_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin: 30px 0;\n  padding-top: 15px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 22px;\n    margin: 0 0 9vh 0;\n    text-align: left;\n  }\n"
    ]);
    Header_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-f055a265-0"
})(Header_styled_templateObject(), device/* default.laptop */.Z.laptop);
var HeaderTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h1",
    family: "bold"
}).withConfig({
    componentId: "sc-f055a265-1"
})(Header_styled_templateObject1(), device/* default.laptop */.Z.laptop);
var HeaderDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f055a265-2"
})(Header_styled_templateObject2(), device/* default.laptop */.Z.laptop);
var HeaderSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f055a265-3"
})(Header_styled_templateObject3(), device/* default.laptop */.Z.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Header/index.tsx



var MulaiInvestasiHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTitle, {
                        children: [
                            "Daftar 100% Online",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Tanpa Minimum Deposit"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSubtitle, {
                        children: "Akun rekening kamu akan diproses secara digital tanpa perlu mengirim dokumen fisik."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/images/pro2-new.svg"
            })
        ]
    });
};
/* harmony default export */ var mulai_investasi_Header = (MulaiInvestasiHeader);

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/Komisi/styled.ts

function Komisi_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 50px;\n  background: url(",
        "/images/mulai-investasi/table-price-left.svg) no-repeat top\n      left,\n    url(",
        "/images/mulai-investasi/table-price-right.svg) no-repeat bottom right;\n  background-size: 50px, 50px;\n\n  > div {\n    width: 50%;\n  }\n\n  @media ",
        " {\n    padding: 100px;\n    background-size: 100px, 100px;\n  }\n"
    ]);
    Komisi_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  width: 100%;\n  @media ",
        " {\n    width: 70%;\n  }\n"
    ]);
    Komisi_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 36px;\n  @media ",
        " {\n    font-size: 50px;\n  }\n  @media ",
        " {\n    font-size: 80px;\n  }\n"
    ]);
    Komisi_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  @media ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    Komisi_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var KomisiList = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f48c19de-0"
})(Komisi_styled_templateObject(), app/* assetPrefix */.Vc, app/* assetPrefix */.Vc, device/* default.tablet */.Z.tablet);
var KomisiContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f48c19de-1"
})(Komisi_styled_templateObject1(), device/* default.laptopL */.Z.laptopL);
var KomisiNumber = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    align: "center",
    family: "bold",
    color: color/* default.primary */.Z.primary
}).withConfig({
    componentId: "sc-f48c19de-2"
})(Komisi_styled_templateObject2(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var KomisiTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-f48c19de-3"
})(Komisi_styled_templateObject3(), device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Komisi/index.tsx




var MulaiInvestasiKomisi = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(KomisiContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Biaya Komisi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(KomisiList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiTitle, {
                                children: "Fee Beli"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiNumber, {
                                children: "0,15%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiTitle, {
                                children: "Fee Jual"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiNumber, {
                                children: "0,25%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "20px",
                align: "center",
                padding: "15px 60px",
                as: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "20px",
                        family: "bold",
                        as: "b",
                        children: "Keterangan:"
                    }),
                    " ",
                    "Sudah termasuk biaya broker, biaya levy (BEI, KPEI, KSEI) 0,043%, PPN biaya",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "broker 10%, dan PPh final untuk transaksi jual 0,1%."
                ]
            })
        ]
    });
};
/* harmony default export */ var Komisi = (MulaiInvestasiKomisi);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Steps/styled.ts

function Steps_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:before {\n    height: 0px;\n    width: 80%;\n    border-bottom: 2px dashed ",
        ";\n    content: '';\n    position: absolute;\n    top: 46px;\n    left: 10%;\n    @media ",
        " {\n      border-bottom: 4px dashed ",
        ";\n      top: 76px;\n      left: 20%;\n      width: 60%;\n    }\n  }\n"
    ]);
    Steps_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: relative;\n  width: calc(100% / 3);\n  margin: 25px 10px;\n  padding: 5px;\n  background: #fff;\n\n  @media ",
        " {\n    background: transparent;\n\n    p {\n      font-size: 19px;\n    }\n  }\n\n  img {\n    max-width: 100%;\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n    @media ",
        " {\n      width: 120px;\n      height: 120px;\n      margin-bottom: 20px;\n      background: ",
        ";\n    }\n  }\n"
    ]);
    Steps_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InvestementContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-326ba20f-0"
})(Steps_styled_templateObject(), color/* default.midgray */.Z.midgray, device/* default.tablet */.Z.tablet, color/* default.midgray */.Z.midgray);
var InvestStep = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "flex-end",
    align: "center",
    direction: "column"
}).withConfig({
    componentId: "sc-326ba20f-1"
})(Steps_styled_templateObject1(), device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet, color/* default.light */.Z.light);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Steps/index.tsx





var MulaiInvestasiSteps = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "3 Langkah Mudah Investasi Saham di Stockbit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestementContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step1.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Pastikan Anda",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " memiliki akun Stockbit"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step2.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Lakukan pengisian ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " formulir pembukaan rekening ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "secara online"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step3.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Deposit ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " dan Beli saham"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Steps = (MulaiInvestasiSteps);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/index.tsx








var MulaiInvestasiFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mulai_investasi_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Komisi, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mulai_investasi_ComparisonGraph, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {})
        ]
    });
};
/* harmony default export */ var mulai_investasi = (MulaiInvestasiFeature);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);